import { callOnce } from '../../utils/initialize';

$(() => {
  const privacyPolicySections = $('.privacy-policy');

  const initializePrivacyPolicySection = (element) => {
    const $element = $(element);
    const policyCheckbox = $element.find('.checkbox input');
    const errorSection = $element.find('.privacy-policy__error-message');

    const onPolicyCheckboxChange = ($event) => {
      if ($event.target.checked) {
        policyCheckbox.val('policy-agreed');
        errorSection.hide();
      } else {
        policyCheckbox.val('');
        errorSection.show();
      }
    };

    policyCheckbox.on('change', onPolicyCheckboxChange);

    // on initial load set checked state if value is set
    if (policyCheckbox.val()) {
      policyCheckbox.attr('checked', true);
    }
  };

  const initializeAllPrivacyPolicySections = () => {
    privacyPolicySections.each((_, element) =>
      initializePrivacyPolicySection(element)
    );
  };

  callOnce(initializeAllPrivacyPolicySections);
});
